import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
import alertHelper from '@/helpers/alert'
import Fees from '@/store/houselist/Fees'
import Keys from '@/store/houselist/Keys'
import Payments from '@/store/houselist/Payments'
import Reports from '@/store/houselist/Reports'
import Lease from '@/store/houselist/Lease'
import Inspections from '@/store/houselist/Inspections'


export default {
  namespaced: true,
  state: {
    houseList: [],
    ownerUploadFile: null,
    tenantUploadFile: null,
    loading: false,
    selectedHouse: {},
  },
  getters: {
    getHouseList: (state) => {
      return state.houseList
    },
    getSelectedHouse: (state) => {
      return state.selectedHouse
    },
    getOwnerUploadFile: (state) => {
      return state.ownerUploadFile
    },
    getLoading: (state) => {
      return state.loading
    },
  },
  mutations: {
    setHouseList(state, status) {
      if (typeof status.length === 'undefined') {
        // When a new house is added display it on the top
        state.houseList.unshift(status)
      } else {
        // We got the whole list
        // Update the state to this new list
        state.houseList = status
      }
    },
    updateHouseList(state, data) {
      data.forEach(d => {
        const pos = state.houseList.findIndex(h => h.id == d.id);
        if (pos >= 0) {
          Vue.set(state.houseList, pos, d)
        }
      });
    },
    setOwnerUploadFile(state, file) {
      state.ownerUploadFile = file
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setSelectedHouse(state, house) {
      state.selectedHouse = house
    },
    deleteHouse(state, houseId) {
      state.houseList.forEach((house, index) => {
        if (house.id === houseId) {
          state.houseList.splice(index, 1)
        }
      })
    },
    setSelectedRoomAreas(state, { roomId, areas }) {
      const mappedAreas = areas.map((area) => {
        return {
          id: area.id,
          name: area.area,
          note: area.note,
        }
      })

      state.selectedHouse.room.forEach((r, index) => {
        if (r.id === roomId) {
          if (typeof state.selectedHouse.room[index].areas !== 'undefined') {
            state.selectedHouse.room[index].areas = []
            state.selectedHouse.room[index].areas = mappedAreas
          } else {
            state.selectedHouse.room[index].areas = mappedAreas
          }
        }
      })
    },
    updateTenants(state, tenants) {
      Vue.set(state.selectedHouse, 'tenant', tenants)
    },
    deleteTenant(state, id) {
      state.selectedHouse.tenant.forEach((tenant, index) => {
        if (tenant.id === id) {
          state.selectedHouse.tenant.splice(index, 1)
        }
      })
    },
    updateFile(state, file) {
      if (typeof state.selectedHouse.files[file.type] === 'undefined') {
        state.selectedHouse.files[file.type] = []
      }
      state.selectedHouse.files[file.type].push(file)
    },
    deleteOwnerContract(state, id) {
      let files = state.selectedHouse.files
      files['owner'] = files['owner'].filter(i => +i.id !== +id)
      Vue.set(state.selectedHouse, 'files', files)
    },

    deleteTenantContract(state, {id, xId}) {
      console.log(id, xId)
      state.selectedHouse.tenant.forEach((tenant, index) => {
        if (+xId === +tenant.id) {
          tenant.files = tenant.files.filter(i => +i.id !== +id)
        }
      })
    },
    updateTenantFile(state, file) {
      state.selectedHouse.tenant.forEach((tenant, index) => {
        if (file.tenant_id === tenant.id) {
          tenant.files.push(file)
        }
      })
    },
  },
  actions: {
    /**
     * Adds a new house
     * Once added it updates the view to display the house added in list
     * and details view
     *
     * @param Object context
     * @param Object house
     */
    async addHouse(context, house) {
      const url = config.apiBaseUrl + 'house/post'

      try {
        const response = await axios.post(url, house)

        if (response.data.errmsg === '') {
          context.dispatch('clearStorage')

          // This API response will give us back `id`
          // Create the key and push it to houselist
          let house = response.data.data
          // Update the `houseList` to display the newly added house
          context.commit(
            'setHouseList',
            Object.assign(house, { id: house.id })
          )
          // Display the newly added house in details view
          context.commit('setSelectedHouse', response.data.data)

          alertHelper.success('Successfully added the house')
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async installDefaultRooms(context, house_id) {
      const url = config.apiBaseUrl + 'house/addDefaultRoomData'

      try {
        const response = await axios.get(url, {params:{id: house_id}})
        if (response.data.errno === 0) {
          context.dispatch('fetchHouse', house_id)
        } else {
          if (response.data.errmsg !== '') {
            alertHelper.error(response.data.errmsg)
          }
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },

    /**
     * Gets all house address for the logged in customer
     *
     * @param Object context
     */
    async list(context, {ids, usage} = {} ) {
      const url = config.apiBaseUrl + 'house/list'
      try {
        if (ids) {
          ids = ids.join(',')
        }
        const response = await axios.get(url, {params:{ids, usage}})

        const now = new Date().toISOString();
        if (response.data.data.length > 0) {
          const houses = response.data.data;
          for (const h of houses) {
            const lease = h.lease ? h.lease.find(l => l.checkin_date < now && l.checkout_date > now): null;
            if (lease) {
              h.leaseCheckoutDate = lease.checkout_date;
            }
          }
          if (ids) {
            context.commit('updateHouseList', houses);
          } else {
            context.commit('setHouseList', houses)
            context.dispatch('Configuration/fetchFeeTypes', null, { root: true })
          }
        } else {
          if (response.data.errmsg !== '') {
            alertHelper.error(response.data.errmsg)
          }
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    /**
     * Gets the house based on ID
     *
     * @param Object context
     * @param Object id House ID
     */
    async fetchHouse(context, id) {
      const url = config.apiBaseUrl + 'house/findById'

      try {
        const response = await axios.get(url, {params:{id}})

        if (response.data.data) {
          const house = response.data.data

          // API returns the decimal
          // Converting this to percentage
          if (house.rental_rate !== '') {
            house.rental_rate = (house.rental_rate * 100).toFixed(1)
          }

          house.files = remapFiles(house.files)

          context.commit('setSelectedHouse', house)
          context.dispatch('Fees/getAll')
          context.dispatch('Lease/getAll', id)
          // context.dispatch('Payments/fetchPaymentsByHouseId', id)
          // context.dispatch('Reports/getReports')
        } else {
          if (response.data.errmsg !== '') {
            alertHelper.error(response.data.errmsg)
          }
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    /**
     * Handles updating house data
     * TODO: Once the issue with updating a new house is fixed
     * this function has to update the house in `houseList`
     *
     * @param Object context
     * @param Object house
     */
    async updateHouse(context, house) {
      // Create a clone as we going to modify the rental rate
      // and this way we are not updating the state/UI
      // const houseClone = JSON.parse(JSON.stringify(house))
      const houseClone = {...house};

      delete houseClone.lease;
      delete houseClone.room;
      delete houseClone.report;
      delete houseClone.files;
      delete houseClone.fee;
      delete houseClone.pay;
      delete houseClone.lease;
      delete houseClone.pm;
      delete houseClone.task;
      delete houseClone.issue;

      const fees = context.rootGetters['HouseList/Fees/get']
      const url = config.apiBaseUrl + 'house/update'

      // API returns the decimal
      // Converting this to percentage
      if (houseClone.rental_rate !== '') {
        houseClone.rental_rate = houseClone.rental_rate / 100
      }

      if (!emptyFeesExists(fees)) {
        try {
          const response = await axios.post(url, houseClone)

          if (response.data.errno === 0) {
            context.dispatch('list', [houseClone.id])
            // context.dispatch('updateTenants', houseClone.id)
            // context.commit('updateHouseList', houseClone)
            // context.dispatch('HouseList/Fees/save', null, { root: true })
            // context.dispatch('HouseList/Payments/saveAll', null, { root: true })
            alertHelper.success('House updated successfully')
          } else {
            alertHelper.error(response.data.errmsg)
          }
        } catch (error) {
          alertHelper.error(error)
        }
      } else {
        alertHelper.error('Please make sure you enter the fee type and amount')
      }
    },
    /**
     * Deletes the house from user's account
     *
     * @param Object context
     * @param Number houseId    House ID
     * @param Number addressId  Address ID
     */
    async deleteHouse(context, { houseId, addressId }) {
      const url = config.apiBaseUrl + 'house/delete'

      try {
        const response = await axios.post(url, { house_id: houseId })

        if (response.data.errmsg === '') {
          context.commit('deleteHouse', houseId)
          context.commit('setSelectedHouse', {})
          context.dispatch('clearStorage')

          alertHelper.success('Successfully deleted house')
        } else {
          alertHelper.error(response.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async fetchContacts(context, houseId) {
      const url = config.apiBaseUrl + 'house/getContacts'

      try {
        const response = await axios.post(url, { house_id: houseId })

        if (response.data.errno === 0) {
          return response.data.data;
        } else {
          alertHelper.error(response.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async updateTenants(context, houseId) {
      try {
        const response = await axios.get(
          config.apiBaseUrl + 'house/' + houseId + '/tenant'
        )

        if (response.data.errno === 0) {
          context.commit('updateTenants', response.data.data)
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },
    async deleteTenant(context, id) {
      const selectedHouse = context.getters.getSelectedHouse
      const url =
        config.apiBaseUrl + 'house/' + selectedHouse.id + '/tenant/' + id

      try {
        const response = await axios.delete(url)

        if (response.data.errno === 0) {
          context.commit('deleteTenant', id)
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
    },

    async deleteContractFile(context, {id, xId, type}) {
      if (!confirm('Are you sure?')) {
        return false
      }
      const url = config.apiBaseUrl + 'house/deleteContractFile'

      if (type !== 'tenant' && type !== 'owner') {
        alertHelper.error('invalid contract type: ' + type)
        return false
      }

      try {
        const response = await axios.post(url, {id, xId, type})

        if (response.data.errno === 0) {
          if (type === 'owner') {
            context.commit('deleteOwnerContract', id)
          } else if (type === 'tenant') {
            context.commit('deleteTenantContract', {id, xId})
          }
          alertHelper.success('Successfully deleted contract file')
          return true
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error)
      }
      return false
    },

    async uploadFile(context, { type, file, tenantId }) {
      const formData = new FormData()
      formData.append('file', file, file.name)
      formData.append('type', type)
      formData.append('house_id', context.getters.getSelectedHouse.id)

      try {
        const response = await axios.post(
          config.apiBaseUrl + 'house/uploadContractFile',
          formData
        )

        if (response.data.errno === 0) {
          if (type === 'owner') {
            context.commit('updateFile', response.data.data)
          }

          alertHelper.success('Document uploaded successfully.')
        } else {
          alertHelper.error(response.data.errmsg)
        }
      } catch (error) {
        alertHelper.error(error.toString())
      }
      return false
    },
    /**
     * Clears the store when selected house is changed
     *
     * @param {object} context
     */
    clearStorage(context) {
      context.commit('Fees/set', [])
      // context.commit('Fees/updateChanged', false)
      context.commit('Payments/setHousePayments', [])
      context.commit('Payments/setNew', [])
      context.commit('Payments/setInfoChanged', false)
      context.commit('Reports/set', [])
    },
  },
  modules: {
    Payments: Payments,
    Keys: Keys,
    Fees: Fees,
    Reports: Reports,
    Lease: Lease,
    Inspections: Inspections,
  },
}

function emptyFeesExists(fees) {
  const emptyFees = fees.filter((f) => f.fee_type_id === '' || f.fee === '')

  return emptyFees.length > 0
}

function remapFiles(files) {
  let remappedFiles = {
    owner: [],
  }

  if (typeof files !== 'undefined' && files.length > 0) {
    files.forEach((file, index) => {
      if (file.type === 'owner') {
        remappedFiles.owner.push(file)
      }
    })
  }

  return remappedFiles
}
